<ul *ngIf="errors?.length > 0">
  <li e2e-id="error" *ngFor="let error of errors">
    {{ error }}
  </li>
</ul>
